import { Content, useContent } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { DividerLine, Stack, Tooltip } from 'src/core/ui';
import { InfoOutlineIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { Event } from 'src/WebApiController';

import { GroupBroadcastSettings } from './components/Broadcast';
import { GroupingMethods } from './components/GroupingMethods';
import { GroupListingsSetting } from './components/GroupListingsSetting';
import { OrderingMethods } from './components/OrderingMethods';
import { RankPremium } from './components/RankPremium';

type GroupListingsBodyProps = {
  event: Event;
};

export const GroupListingsBody: React.FC<GroupListingsBodyProps> = ({
  event,
}) => {
  const rankPremiumTips = useContent(ContentId.RankPremiumTips);
  return (
    <Stack direction="column" gap="m" width="full">
      <GroupListingsSetting
        title={<Content id={ContentId.GroupInventory} />}
        content={<GroupingMethods />}
        defaultToOpen
      />
      <DividerLine />
      <GroupListingsSetting
        title={
          <Stack alignItems="center" gap="s">
            <Content id={ContentId.GroupListingsSettingRankPremium} />
            <Tooltip
              delayDuration={100}
              contentVariant="dark"
              triggerContent={
                <div style={{ display: 'flex' }}>
                  <InfoOutlineIcon
                    size={vars.iconSize.m}
                    title={rankPremiumTips}
                  />
                </div>
              }
            >
              <Content id={ContentId.RankPremiumTips} />
            </Tooltip>
          </Stack>
        }
        content={<RankPremium />}
      />
      <DividerLine />
      <GroupListingsSetting
        title={<Content id={ContentId.GroupListingsSettingQueuingLogic} />}
        content={<OrderingMethods />}
      />
      <DividerLine />
      <GroupListingsSetting
        title={<Content id={ContentId.GroupListingsSettingBroadcasting} />}
        content={<GroupBroadcastSettings event={event} />}
      />
    </Stack>
  );
};
